module.exports = __webpack_public_path__ + "static/img/account.e7f31cff.png";